module.exports = __webpack_public_path__ + "media/images/technology/MGISP-100-6de8cbf59e2bd1251beb01e4b9c27f49.png";